import React, { useState, MouseEvent } from 'react';
import Customer from '../../../types/Customer';
import CheckboxField from '../../checkbox-field';
import useUpdateCustomerPermissions from '../../../hooks/use-update-customer-permissions';
import Button from '../../button';

interface Props {
  customer: Customer;
}

const AdminUserPermissionsForm: React.FC<Props> = ({ customer }) => {
  const [permissions, setPermissions] = useState(customer.permissions);
  const [message, setMessage] = useState('');
  const updateCustomerPermissions = useUpdateCustomerPermissions();

  const onChange = (id:string) => {
    // need a case-insensitive match
      if (permissions.some(r => r.toLowerCase() === id.toLowerCase()))  {
          const copy = permissions.filter(r => r.toLowerCase() !== id.toLowerCase())
          setPermissions(copy);
      } else {
          const copy:string[] = Object.assign([], permissions);
          copy.push(id);
          setPermissions(copy);
      }
  };

  const onClick = async (e:MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    await updateCustomerPermissions(process.env.SITE!, customer.id, permissions);
    setMessage('Successfully updated permission details.');
  };

  return (
    <form>
      <h2>Permissions</h2>
      <div className="permissions">
        {[
          {
            id: 'system_admin',
            label: 'System Admin',
          },
          {
            id: 'FOC',
            label: 'Free of Charge',
          },
          {
            id: 'helpSystemAdmin',
            label: 'Help System Admin',
          },
          {
            id: 'taxExempt',
            label: 'Tax Exempt',
          },
          {
            id: 'resaleCertified',
            label: 'Retail Certified Tax Exemption',
          },
          {
            id: 'forceCCPayment',
            label: 'Force Credit Card Payment',
          },
          {
            id: 'GDST',
            label: 'GDST Admin',
          },
          {
            id: 'partsDeptAdmin',
            label: 'Modify Parts Depts Information',
          },
          {
            id: 'bulletinTechnician',
            label: 'Upload Bulletin Media',
          },
          {
            id: 'specialToolAdmin',
            label: 'Special Tool Admin',
          },
          {
            id: 'consecutiveSWDL',
            label: 'Consecutive SWDL',
          },
          // @ts-ignore
        ].map((permission) => (
          <CheckboxField
            key={permission.id}
            id={permission.id}
            label={permission.label}
            checked={permissions.some((r) => r === permission.id)}
            onChange={() => onChange(permission.id)}
          />
        ))}
      </div>
      {message && <p>{message}</p>}
      <Button text="Save" onClick={onClick} />
      {/* language=CSS */}
      <style jsx>{`
        .permissions {
          display: flex;
          flex-wrap: wrap;
        }

        .permissions > :global(.form-group) {
          flex-grow: 0;
          width: 33%;
          margin-bottom: 1rem;
        }
      `}</style>
    </form>
  );
};

export default AdminUserPermissionsForm;
